import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { keep: Array, url: String }

  navigate(event) {
    event.preventDefault()
    const params = new URLSearchParams()
    this.keepValue.forEach((field) => {
      const input = document.querySelector(`#${field}`)
      if (input) params.set(field, input.value)
    })
    const base = this.hasUrlValue ? this.urlValue : window.location.pathname
    window.location.href = `${base}?${params}`
  }
}
